export const locale = {
  lang: 'en',
  'apis_status': {
    'REFRESH': 'Refresh',
    'ENABLE': 'Enable'
  }
};
